var _circle, _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarlyWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 73,
    viewBox: "0 0 104 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 36.5,
    r: 36.266,
    fill: "url(#paint0_linear_506_3333)",
    stroke: "#81A9D7",
    strokeWidth: 0.467949
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5165 21.6545C77.5894 21.612 77.663 21.569 77.7374 21.5256C78.3617 21.1614 78.9668 20.8454 79.5552 20.5751C82.2679 25.2587 83.8207 30.698 83.8207 36.5C83.8207 54.074 69.5742 68.3205 52.0002 68.3205C34.4262 68.3205 20.1797 54.074 20.1797 36.5C20.1797 31.6712 21.2553 27.0936 23.18 22.9937C23.5112 23.1038 23.838 23.2148 24.1612 23.3245C28.3328 24.7409 31.9026 25.953 36.5579 22.4615C44.0451 16.8461 52.9361 17.3141 61.8271 21.5256C70.6091 25.6855 71.6497 25.0782 77.5165 21.6545Z",
    fill: "url(#paint1_linear_506_3333)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_506_3333)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 35.5,
    rx: 41.5,
    ry: 16.5,
    fill: "#FFBD7B",
    fillOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.496 34.02H50.496V35.196H48.18C48.132 35.556 48.072 35.884 48 36.18H50.172V42.024H48.996V37.284H45.984V42.024H44.808V36.18H46.788C46.836 35.972 46.892 35.644 46.956 35.196H44.496V34.02ZM48.528 41.94C49.36 42.604 50.06 43.248 50.628 43.872L49.752 44.748C49.248 44.092 48.572 43.416 47.724 42.72L48.528 41.94ZM46.86 37.848H48.06V39.96C48.012 41.256 47.716 42.292 47.172 43.068C46.628 43.796 45.768 44.352 44.592 44.736L43.908 43.668C45.036 43.292 45.804 42.832 46.212 42.288C46.596 41.688 46.812 40.912 46.86 39.96V37.848ZM40.944 35.604C41.2 35.844 41.46 36.112 41.724 36.408C42.02 36.08 42.324 35.668 42.636 35.172H39.816V34.02H43.968V34.992C43.504 35.856 42.992 36.596 42.432 37.212L42.864 37.74H44.292V38.496C44.1 39.448 43.88 40.18 43.632 40.692L42.612 40.296C42.796 39.92 42.968 39.452 43.128 38.892H42.264V43.548C42.264 44.308 41.912 44.688 41.208 44.688H40.032L39.768 43.56C40.128 43.608 40.468 43.632 40.788 43.632C40.98 43.632 41.076 43.504 41.076 43.248V38.892H39.48V37.74H41.508C41.108 37.284 40.616 36.764 40.032 36.18L40.944 35.604ZM51.864 34.068H53.172V33.612H54.204V34.068H55.2V33.612H56.232V34.068H57.576V34.956H56.232V35.376H55.2V34.956H54.204V35.376H53.544L53.496 35.556H57.24V36C57.848 35.384 58.26 34.572 58.476 33.564L59.604 33.756L59.472 34.248H62.148V35.256H61.5C61.348 35.952 61.084 36.552 60.708 37.056C61.18 37.32 61.744 37.548 62.4 37.74L61.836 38.724C61.092 38.476 60.452 38.176 59.916 37.824C59.372 38.224 58.688 38.52 57.864 38.712L57.408 37.704C58.056 37.568 58.6 37.368 59.04 37.104C58.784 36.832 58.588 36.568 58.452 36.312C58.276 36.528 58.068 36.744 57.828 36.96L57.228 36.204C57.204 37.276 57.108 37.952 56.94 38.232C56.884 38.312 56.832 38.372 56.784 38.412L57.348 38.328C57.484 38.624 57.584 38.848 57.648 39H62.22V39.876H51.792V39H56.436C56.372 38.864 56.308 38.756 56.244 38.676C56.164 38.692 56.036 38.708 55.86 38.724H55.368L55.284 38.448H52.74V37.044C52.54 37.284 52.348 37.48 52.164 37.632L51.504 36.816C52.008 36.408 52.356 35.852 52.548 35.148L53.172 35.256V34.956H51.864V34.068ZM55.404 37.944H55.632C55.832 37.92 55.96 37.82 56.016 37.644C56.056 37.468 56.084 37.04 56.1 36.36H53.172L52.98 36.708H55.404V37.944ZM54.492 37.836V37.332H53.652V37.836H54.492ZM59.088 35.256L59.04 35.352C59.192 35.752 59.452 36.116 59.82 36.444C60.116 36.084 60.324 35.688 60.444 35.256H59.088ZM53.244 40.236H60.864V40.944H53.244V40.236ZM53.244 41.316H60.864V42.024H53.244V41.316ZM61.32 42.444V44.844H60.108V44.532H54.036V44.844H52.812V42.444H61.32ZM54.036 43.74H60.108V43.236H54.036V43.74Z",
    fill: "#112C56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_506_3333",
    x: 0.0179482,
    y: 8.51795,
    width: 103.964,
    height: 53.9641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24103,
    result: "effect1_foregroundBlur_506_3333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_3333",
    x1: 52,
    y1: 0,
    x2: 52,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10234E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16547B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_506_3333",
    x1: 83.8207,
    y1: 36.868,
    x2: 20.1797,
    y2: 36.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF630B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491939,
    stopColor: "#F6A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF630B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyWarn);
export default __webpack_public_path__ + "static/media/early-warn.10d353c3c2d174f7b24511f97b919c8e.svg";
export { ForwardRef as ReactComponent };